/**
 * Sigorta (AOS/MCB) fiziksel olculeri (cm cinsinden)
 * Kaynak: docs/aos.png - uretici datasheet olculeri
 *
 * Kutup genislikleri: 1P=18mm, 2P=36mm, 3P=54mm, 4P=72mm
 * Yukseklik: ~85mm (standart DIN ray MCB)
 */

export const BREAKER_PHYSICAL = {
  poleWidth: 1.8,         // 18mm - tek kutup modül genisligi
  height: 8.5,            // 85mm - standart MCB yuksekligi

  // Dikey bolgeler (ustten alta)
  topTermH: 1.2,          // ust terminal bolgesi
  upperBodyH: 1.3,        // ust govde
  handleH: 2.2,           // salter kolu/tutamag bolgesi
  arcWindowH: 0.6,        // ark gosterge penceresi
  lowerBodyH: 1.3,        // alt govde
  bottomTermH: 1.9,       // alt terminal bolgesi

  // Terminal vida capı
  screwR: 0.35,           // ~7mm cap terminal vidasi
};

/**
 * Faz sayisina gore sigorta olculerini dondur
 * @param {number} phase - 1 veya 3
 * @returns {object} { ...BREAKER_PHYSICAL, poles, width }
 */
export function getBreakerPhysical(phase) {
  // 1F → 2P (L+N), 3F → 4P (3L+N)
  const poles = phase === 3 ? 4 : 2;
  return {
    ...BREAKER_PHYSICAL,
    poles,
    width: BREAKER_PHYSICAL.poleWidth * poles,
  };
}
